import type { Style } from 'inlines'

export type Size = 'small' | 'medium' | 'large' | 'xlarge'

export const linkStyle: Style = {
  display: 'inline-flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.25rem',
  cursor: 'pointer',
  color: 'var(--brand-secondary)',
  textDecoration: 'underline',
  borderBottom: '1px solid transparent',
  transition: 'opacity 0.2s ease',
}
export const linkSizeStyle: Record<Size, Style> = {
  xlarge: {
    fontSize: '2rem',
  },
  large: {
    fontSize: '1.5rem',
  },
  medium: {
    fontSize: '1.125rem',
  },
  small: {
    fontSize: '1rem',
  },
}
export const linkIconSizeStyle: Record<Size, Style> = {
  xlarge: {
    height: '2rem',
    width: '2rem',
    aspectRatio: '1/1',
  },
  large: {
    height: '1.5rem',
    width: '1.5rem',
    aspectRatio: '1/1',
  },
  medium: {
    height: '1.125rem',
    width: '1.125rem',
    aspectRatio: '1/1',
  },
  small: {
    height: '1rem',
    width: '1rem',
    aspectRatio: '1/1',
  },
}
